export function getSettingsDialogModalStyle() {
    return {
        main: {
            height: "652px",
            overflow: "hidden",
            width: "653px",
        },
    };
}
export function getMainStackStyle() {
    return {
        root: {
            height: "581px", //653 - window margins
        },
    };
}
export function getSettingsDialogMainHeaderStackStyle() {
    return {
        root: {
            marginBottom: "20px",
        },
    };
}
export function getCPRAIconStyle(theme) {
    return {
        // eslint-disable-next-line
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='30' height='14' viewBox='0 0 30 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_20_99477)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M22.6 0H7.4c-3.9 0-7 3.1-7 7s3.1 7 7 7h15.2c3.9 0 7-3.1 7-7s-3.2-7-7-7zm-21 7c0-3.2 2.6-5.8 5.8-5.8h9.9l-3.1 11.6H7.4c-3.2 0-5.8-2.6-5.8-5.8z' fill='%2306F'/%3E%3Cpath d='M24.6 4c.2.2.2.6 0 .8L22.5 7l2.2 2.2c.2.2.2.6 0 .8-.2.2-.6.2-.8 0l-2.2-2.2-2.2 2.2c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8L20.8 7l-2.2-2.2c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0l2.2 2.2L23.8 4c.2-.2.6-.2.8 0z' fill='%23fff'/%3E%3Cpath d='M12.7 4.1c.2.2.3.6.1.8L8.6 9.8c-.1.1-.2.2-.3.2-.2.1-.5.1-.7-.1L5.4 7.7c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0L8 8.6l3.8-4.5c.2-.2.6-.2.9 0z' fill='%2306F'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_20_99477'%3E%3Cpath fill='%23fff' d='M0 0h30v14H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        cursor: "pointer",
        display: "inline-block",
        height: "14px",
        marginLeft: "4px",
        width: "30px",
    };
}
export function getCPRATextContainerStyle(theme) {
    return {
        root: {
            alignItems: "center",
            alignSelf: "flex-end",
            display: "flex",
        },
    };
}
export function getBulletIconStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textDisabled,
            verticalAlign: "middle",
        },
    };
}
export function getEditIconStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.accentTextPrimary,
            marginRight: "10px",
        },
    };
}
export function getDescriptionStackStyle(them) {
    return {
        root: {
            width: "362px",
        },
    };
}
export function getDescriptionTextStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textSecondary,
            marginBottom: "20px",
        },
    };
}
export function getSettingsHeadersTextStyle() {
    return {
        root: {
            marginBottom: "4px",
            width: "332px",
        },
    };
}
export function getSubtleLinkStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textTertiary,
        },
    };
}
export function getLinkStyle() {
    return {
        root: {
            textAlign: "right",
        },
    };
}
export function getSettingsToggleStyle() {
    return {
        root: {
            alignItems: "center",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            margin: "4px 20px 4px 0px",
        },
    };
}
export function getSettingTextAreaStackStyle() {
    return {
        root: {
            alignItems: "left",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            margin: "4px 0px 4px 12px",
        },
    };
}
export function getSettingsToggleStackStyle(theme) {
    return {
        root: {
            backgroundColor: theme.customSemanticColors.cardBackgroundDefault,
            border: "solid 1px",
            borderColor: theme.customSemanticColors.cardStrokeDefault,
            borderRadius: "3px",
            flexContainer: {
                maxWidth: "none",
            },
            justifyContent: "center",
            marginBottom: "4px",
            minHeight: "80px",
            verticalAlignment: "center",
            width: "581px",
        },
    };
}
export function getTitleStyles() {
    return {
        root: {
            display: "flex",
            height: "fit-content",
            marginBottom: "5px",
            marginTop: "5px",
            width: "194px",
        },
    };
}
